export const sv = {
  header: { title: "Digital provtagning", samplingSession: "Provtagning" },
  join: {
    joinSession: "Anslut till session",
    connecting: "Ansluter till session…",
  },
  controls: {
    microphone: "Mikrofon",
    camera: "Kamera",
    screenShareStart: "Dela skärm",
    screenShareStop: "Stoppa delning",
    leave: "Lägg på",
  },
  waitRoom: {
    heading: "Ett ögonblick",
    text: "Vi kommer släppa in dig i sessionen inom kort",
  },
  landingPage: {
    buttonLabel: "Ok",
    label: "Ange sessions-ID",
  },
  getStarted: {
    buttonText: "Kom igång",
  },
  status: {
    settingUp: "Startar…",
    disconnectedFromSession: "Du har kopplats bort från sessionen",
  },
  errors: {
    genericError: "Något gick fel",
    genericErrorExtended: "Något gick fel, prova igen senare",
    tryAgainLater: "Prova igen senare eller kontakta support",
  },
} as const;
